import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Button, Divider } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useEffect } from 'react';
import { isLoadingSelector, passwordlessThunk, updateStepToDisplay, } from '../../../redux/features/passwordless/passwordlessSlice.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { accountIdentifierEmailSelector } from '../../../views/AccountIdentifier/accountIdentifierSlice.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { useOptimizelyExperiment } from '../../../redux/core/experiments/useOptimizelyExperiment.js';
import { PasswordlessLoginExperimentKey } from '../../../redux/core/experiments/allExperiments/passwordlessLogin.js';
import { loginSourceSelector, redirectionUrlSelector, } from '../../../redux/core/sourceData/sourceDataSlice.js';
import { isPasswordlessEnabledSelector } from '../../../redux/core/siteConfig/siteConfigSlice.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
import { updateEmailError, updateEmailErrorMessage, } from '../../../views/Login/loginSlice.js';
export const PasswordlessButton = ({ dividerText, buttonText, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const isPasswordlessExperimentEnabled = useOptimizelyExperiment(PasswordlessLoginExperimentKey) === 'B';
    // until linkedin experiment will be done, passwordless experiment config is needed
    const shouldShowPasswordlessButton = useAppSelector(isPasswordlessEnabledSelector) ||
        isPasswordlessExperimentEnabled;
    const isLoading = useAppSelector(isLoadingSelector);
    const email = useAppSelector(accountIdentifierEmailSelector);
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const loginSource = useAppSelector(loginSourceSelector);
    const { trackBtnClick, trackFieldError } = useTrack('passwordLess');
    useEffect(() => {
        dispatch(updateStepToDisplay('twoStepLogin'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onClick = () => {
        const isValidEmail = validateEmail(email?.value);
        if (isValidEmail) {
            trackBtnClick({ uniqueName: 'oneTimePasswordless' });
            dispatch(passwordlessThunk({
                email: email.value,
                returnUrl: redirectionUrl,
                loginSource,
            }));
        }
        else {
            trackFieldError({ formFieldErrors: 'emailAddressNotValid' });
            dispatch(updateEmailError(!isValidEmail));
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
        }
    };
    return shouldShowPasswordlessButton ? (_jsxs(_Fragment, { children: [_jsx(Divider, { py: "spaceM", children: dividerText ?? t('loginregistration.twoStepLoginRegistration.divider') }), _jsx(Button, { "data-testid": "passwordless-onet-time-link-button", autoFocus: true, variant: "secondary", a11yLabel: "One time passwordless login", type: "submit", onClick: onClick, isLoading: isLoading, isFullWidth: true, size: ['medium'], children: buttonText ?? t('loginregistration.passwordless.oneTimeLinkButton') })] })) : null;
};
//# sourceMappingURL=PasswordlessButton.js.map